<template>
  <div>
    <div v-if="isLeft(side)" class="row">
      <div class="col-12">
        <row-section-header>
          <span slot="title">
            Projects
          </span>
        </row-section-header>
        <p>
          With a background in visual and motion design, I have built up my skillset in various areas of the digital world. This has allowed me to culminate my skills in creating digital experiences, where I always strive to learn and grow as much as possible in user-centered design.
        </p>
      </div>
    </div>
    <div v-if="isRight(side)">
      <div class="row" v-for="proj in projects">
        <div class="col-12 p-0">
          <router-link :to="{ name: proj.name }">
            <div class="v-align-wrapper half-height thumbnail-img">
              <div class="has-bg-img" :style="thumbnailBg(proj)"></div>
              <div class="v-align w-100">
                <h4 class="text-center text-white serif p-3">{{ proj.title }}</h4>
                <h5 class="text-center small text-white">{{ proj.types }}</h5>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AffixedSectionBase from '@/components/AffixedSectionBase.js'

export default {
  name: 'projects',
  mixins: [AffixedSectionBase],
  data: function () {
    return {
      projects: [
        {
          name: 'project-1',
          thumbnailPath: '@/../static/Warehouse.jpg',
          color: '#4CC2C0',
          title: 'IKEA Dashboard',
          types: 'UX / Concept / Research',
        },
        {
          name: 'project-2',
          thumbnailPath: '@/../static/Players.jpg',
          color: '#FBBD16',
          title: 'Second Stage App Concept',
          types: 'Interaction Design / Motion / UX',
        },
        {
          name: 'project-3',
          thumbnailPath: '@/../static/LinkImage.jpg',
          color: '#F15C5A',
          title: 'IKEA 40th Anniversary Video',
          types: 'Motion / Narrative / Illustration',
        },
        {
          name: 'gallery',
          thumbnailPath: '@/../static/Gallery-image-for-homepage.png',
          color: '#4CC2C0',
          title: 'Motion Gallery',
          types: 'Collection of recent motion projects',
        },
//        {
//          name: 'project-1',
//          thumbnailPath: '@/../static/LinkImage-Milk.jpg',
//          color: '#FFF3E9',
//          title: 'Milk Cartons Presentation',
//          types: 'Illustration / Narrative / Design / Education',
//        },
      ]
    }
  },
  methods: {
    thumbnailBg: function (proj) {
      return {
        backgroundImage: "url(" + proj.thumbnailPath + ")",
        backgroundColor: proj.color
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.half-height {
  min-height: 50vh;
}
.thumbnail-img {
  overflow: hidden;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  &:focus .has-bg-img,
  &:hover .has-bg-img {
    transform: scale(1.2);
  }
  .has-bg-img {
    opacity: .9;
    z-index: 3;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    transition: all 1s;
    background-blend-mode: multiply;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sections/main/Projects.vue